import type { SVGProps } from 'react';

export function CustomIconMeasureTable(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M4 8.26655V11.4666H7V8.26655H4Z" fill="currentColor" />
      <path d="M4 16.8V20H7V16.8H4Z" fill="currentColor" />
      <path opacity="0.5" d="M4 3.99995V7.19995H7V3.99995H4Z" fill="currentColor" />
      <path
        opacity="0.5"
        d="M8 7.19995V3.99995L13 3.99995V7.19995H8Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M14 7.19995V3.99995L20 3.99995V7.19995H14Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      />
      <path d="M8 11.4666V8.26655H13V11.4666H8Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
      <path d="M14 11.4666V8.26655H20V11.4666L14 11.4666Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
      <path d="M14 15.7334V12.5334H20V15.7334L14 15.7334Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
      <path d="M8 15.7334V12.5334H13V15.7334L8 15.7334Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
      <path d="M8 20V16.8H13V20H8Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
      <path d="M14 20V16.8H20V18.5V20H14Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
      <path opacity="0.5" d="M4 12.5334V15.7334H7V12.5334H4Z" fill="currentColor" />
    </svg>
  );
}
